import { USER_ROLE } from 'data/constants/common_constants';

export const POLICY_CANCEL_LOG_ROWS_PER_PAGE_OPTIONS = [10, 20, 30, 40, 50];

export function toPlainCancelLogs(cancelLogsRaw) {
  if (cancelLogsRaw == null) {
    return null;
  }

  const raw = typeof cancelLogsRaw.toJS === 'function' ? cancelLogsRaw.toJS() : cancelLogsRaw;

  if (raw && typeof raw === 'object' && !Array.isArray(raw)) {
    const data = Array.isArray(raw.data) ? raw.data : [];
    return {
      ...raw,
      data: data.filter((log) => log?.application),
    };
  }

  if (Array.isArray(raw)) {
    const data = raw.filter((log) => log?.application);
    return {
      data,
      total: data.length,
      isLoading: false,
    };
  }

  return {
    data: [],
    total: 0,
    isLoading: false,
  };
}

export function formatCancelLogRole(role) {
  if (!role) return '—';
  return USER_ROLE[role] || role;
}

export function formatCancelLogDate(value) {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleString();
}

/**
 * @param {object} log - cancel log row from API
 * @param {number} entryIndex - stable index in normalized list
 * @param {boolean} isDemo
 */
export function buildCancelLogTableRow(log, entryIndex, isDemo) {
  const app = log.application;
  return {
    entryIndex,
    application: app,
    user_role_code: log.user?.role || '',
    created_at: log.createdAt || null,
    rider_id: isDemo ? null : log.rider_id || '—',
    tenant_name: isDemo ? null : app.tenant_1_name || '—',
    building_name: isDemo ? null : app.apartment_building_name || '—',
    cancelled_by: isDemo ? null : log.user?.email || '—',
    user_role: formatCancelLogRole(log.user?.role),
    cancellation_date: formatCancelLogDate(log.createdAt),
  };
}

export function cancelLogRowToTableData(row, isDemo, getDemoDataFn) {
  return [
    isDemo ? getDemoDataFn('rider-id') : row.rider_id,
    isDemo ? getDemoDataFn('tenant-name') : row.tenant_name,
    isDemo ? getDemoDataFn('building-name') : row.building_name,
    isDemo ? getDemoDataFn('email') : row.cancelled_by,
    row.user_role,
    row.cancellation_date,
    row.entryIndex,
  ];
}
